import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { AmountActions } from './amount.actions';

@Injectable({
  providedIn: 'root'
})
export class AmountEffects {
  sendAmountEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendAmountEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(AmountActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
